import VideoJsAdapter from "../../../adapters/videojs_adapter";
import Button from "../../button";

export default class Index extends Button {
  constructor(player, options = {}){
    super(player, options);
  }

  buildCSSClass(){
    if(this.options_.ignoreClick) {
      return `vjs-vidio-logo ${super.buildCSSClass()} ignore-click`;
    } else {
      return `vjs-vidio-logo ${super.buildCSSClass()}`;
    }
  }

  handleClick(){
    if(this.options_.ignoreClick) return;

    this.triggerLogoClick();
    this.redirectWatchpage(this.constructUrl());
  }

  constructUrl() {
    const streamType = this.options_.streamType;
    const typeEndpoint = {
      'TvStream': '/live/',
      'EventStream': '/live/',
      '': '/watch/'
    };

    return [
      window.location.origin,
      typeEndpoint[streamType],
      this.options_.videoId,
      '?utm_source=embed&utm_medium=VidioLogo'
    ].join('');
  }

  redirectWatchpage(url){
    window.open(url, '_blank');
  }

  triggerLogoClick(){
    this.player().trigger({ type: "vp-vidio-logo-clicked", id: this.options_.videoId });
  }
}

Index.prototype.controlText_ = "Tonton di Vidio";
VideoJsAdapter.registerComponent('VpVidioLogo', Index);
